import React, { useState, useEffect } from 'react';
import './Review.css';
import axios from 'axios';
import { SERVER_URL } from '../../util/EnvironmentConfig';
import { jwtDecode } from 'jwt-decode';

const Review = () => {
  const [reviews, setReviews] = useState([]);
  const [referralLink, setReferralLink] = useState('');
  const [userData, setUserData] = useState(null);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    alert('Referral link copied to clipboard!');
  };

  useEffect(() => {
    // Run only on client
    const token = localStorage.getItem('loginToken');

    if (token) {
      const decoded = jwtDecode(token);
      setUserData(decoded);
      setReferralLink(`${window.location.origin}/refer/${decoded.referralId}`);
    }
  }, []);

  useEffect(() => {
    const fetchReviews = async () => {
      if (!userData) return;
      try {
        const url = `${SERVER_URL}/user/reviews`;
        const response = await axios.post(
          url,
          {
            userId: userData.id,
          },
          {
            headers: { 'Content-Type': 'application/json' },
          },
        );
        setReviews(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    if (userData) {
      fetchReviews();
    }
  }, [userData]);

  return (
    <>
      {/* Recent Reviews Section */}
      <div className="mb-5">
        <h3 className="font-bold text-xl mb-3 text-center">Recent Reviews</h3>
        {reviews.length > 0 ? (
          reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gray-900 p-3 my-2 text-white rounded-lg"
            >
              <p>
                Review:{' '}
                <span className="text-gray-400 font-bold ml-1">
                  {review.contentName}
                </span>
              </p>
              <p>
                Family:{' '}
                <span className="text-gray-400 font-bold ml-1">
                  {review.family}
                </span>
              </p>
              <p>
                Category:{' '}
                <span className="text-gray-400 font-bold ml-1">
                  {review.category}
                </span>
              </p>
              <p>
                Points Earned:
                <span className="text-green-400 font-bold ml-1">
                  {review.pointsEarned}
                </span>
              </p>
            </div>
          ))
        ) : (
          <div className="review">
            <p>No recorded reviews</p>
          </div>
        )}
      </div>

      {/* Refer a Friend Section */}
      <div className="bg-gray-900 p-3 rounded-lg">
        <h3 className="font-bold text-xl mb-3 text-center">Refer a Friend!</h3>
        <div className="flex flex-col px-2">
          <p className="text-gray-400 font-bold">
            Share this link with a friend to refer them:
          </p>
          <input
            type="text"
            value={referralLink}
            readOnly
            className="referral-link"
          />
          <button
            onClick={copyToClipboard}
            className="bg-[#FF9933] hover:bg-[#F2994A] rounded-md py-2 px-3 mt-2"
          >
            Copy Link
          </button>
        </div>
      </div>
    </>
  );
};

export default Review;
